import React, { FC, FormEvent, useCallback, useState } from "react";
import { Grid, TextField, Button } from "@material-ui/core";
import * as yup from "yup"; // for everything
import { useI18n } from "utils/i18n/hooks/useI18n";

interface ILoginPostObject {
  email: string;
  password: string;
}

interface ILoginProps {
  emailSugestion?: string;
  onSubmit: (username: string, password: string) => void
}

export const Login: FC<ILoginProps> = ({ emailSugestion, onSubmit }) => {
  const [values, setValues] = useState({ email: "", password: "" });
  const { t } = useI18n();

  const cardSchema = yup.object<ILoginPostObject>().shape({
    email: yup.string().email(t("auth.login.emailInvalid")).required(t("auth.login.emailRequired")),
    password: yup.string().min(4, t("auth.login.passwordMinLength")).required(t("auth.login.passwordRequired")),
  });

  const changeNameHandle = useCallback((value: string) => {
    setValues((prev) => ({ ...prev, email: value }));
  }, []);
  const changePasswordHandle = useCallback((value: string) => {
    setValues((prev) => ({ ...prev, password: value }));
  }, []);

  const submitHandle = useCallback(
    (ev: FormEvent<HTMLFormElement>) => {
      ev.preventDefault();
      onSubmit(values.email, values.password);
    },
    [values, onSubmit]
  );

  return (
    <form onSubmit={submitHandle}>
      {t("auth.login.useEmail")} {emailSugestion}
      <Grid spacing={1} container>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            required
            // helperText={touched.email && errors.email}
            // error={touched.email && Boolean(errors.email)}
            onChange={(ev) => changeNameHandle(ev.target.value)}
            value={values.email}
            name="email"
            label={t("auth.login.email")}
            inputProps={{ inputMode: "email" }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            // helperText={touched.password && errors.password}
            // error={touched.password && Boolean(errors.password)}
            onChange={(ev) => changePasswordHandle(ev.target.value)}
            required
            value={values.password}
            name="password"
            label={t("auth.login.password")}
            type="password"
          />
        </Grid>
        <Grid item xs={12}>
          <Button fullWidth size="large" variant="contained" color="primary" type="submit">
            {t("auth.login.enter")}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button size="small" variant="text" color="primary" type="submit">
            {t("auth.login.forgotPassword")}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
// function setValues(arg0: (prev: any) => any) {
//   throw new Error("Function not implemented.");
// }
